export default {"src":"/_next/static/media/arrow-right.2385945d.svg","height":7,"width":4,"blurWidth":0,"blurHeight":0};